import { CreateBase, Form, useGetIdentity } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { FormToolbar } from "../layout/FormToolbar";
import { GroupInputs } from "./GroupInputs";

export const GroupCreate = () => {
  const { identity } = useGetIdentity();
  return (
    <CreateBase redirect="list">
      <div className="mt-2 flex max-w-md">
        <Form
          className="flex-1"
          defaultValues={{ sales_id: identity?.id, color: "#99c1de" }}
        >
          <Card>
            <CardContent>
              <GroupInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>
      </div>
    </CreateBase>
  );
};
